import ls from '@/helpers/localStorage';
import { getWrapperForTracking } from '@/mixins/userAgent';
import sessionVars from '@/helpers/sessionVars';
import log from '@/logger';
import { uuidv4 } from '@/utils/helpers';

const INSTALL_DATE_KEY = 'mmp_install_date';
const RETENTION_FIRED_KEY = 'mmp_retention_fired';
const RETENTION_DAYS = [1, 7, 30];

export const INTERACTION_TYPE = {
  CONTRACT_CURRENT_PRICE_LIST: 'Contract_Current_Price_List',
  READ_MORE: 'Read_More',
  MARKET_TILE: 'Market_Tile',
  CHART_INTERACTION: 'Chart_Interaction',
  VIDEO_PLAY: 'Video_Play',
  VIEW_MARKET: 'View_Market',
};

export const pushDataLayer = (payload) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

export const withMeta = (payload) => {
  const event = {
    wrapper: getWrapperForTracking(),
    ...payload,
  };
  log.info('[DATALAYER] New event', event);
  return event;
};

export const pushInstall = mmpInstallId => pushDataLayer(withMeta({ event: 'install', mmpInstallId }));

export const pushRetention = (retentionMark, day) =>
  pushDataLayer(withMeta({ event: 'retention', retentionMark, day }));

export const pushPageview = (virtualPage, virtualPageTitle) =>
  pushDataLayer(withMeta({ event: 'pageviewTrackerEvent', virtualPage, virtualPageTitle }));

export const pushUserIdentity = (gtmUserID, otmUserID) =>
  pushDataLayer(withMeta({ gtmUserID, otmUserID }));

export const getUniqueViewGUID = () => uuidv4();

export const pushPreviewUniqueView = ({
  storyId, storyVersionId, sectionId, sectionType, previewUniqueViewGUID,
}) =>
  pushDataLayer(withMeta({
    event: 'Preview_Unique_View',
    Story_Id: storyId,
    Story_Version_Id: storyVersionId,
    Section_Id: sectionId,
    Section_Type: sectionType,
    PreviewUniqueViewGUID: previewUniqueViewGUID,
  }));

export const pushStoryInteraction = ({
  interactionType, storyId, storyVersionId, sectionId,
  regionId, regionTrackingId, previewUniqueViewGUID,
}) => pushDataLayer(withMeta({
  event: 'Story_Interaction',
  Interaction_Type: interactionType,
  Story_Id: storyId,
  Story_Version_Id: storyVersionId,
  Section_Id: sectionId,
  Region_Id: regionId,
  Region_Tracking_Id: regionTrackingId,
  PreviewUniqueViewGUID: previewUniqueViewGUID,
}));

const getDaysSinceInstall = (installTimestamp) => {
  const nowDay = new Date().setHours(0, 0, 0, 0);
  const installDay = new Date(installTimestamp).setHours(0, 0, 0, 0);
  return Math.floor((nowDay - installDay) / 86400000);
};

export const fireTrackMMPInstall = () => {
  const mmpInstallIdVar = sessionVars.get('mmpInstallId');
  if (!mmpInstallIdVar) return;
  pushInstall(mmpInstallIdVar.value);
};

export const fireTrackRetention = () => {
  let installDate = ls.get(INSTALL_DATE_KEY);
  if (!installDate) {
    installDate = Date.now();
    ls.set(INSTALL_DATE_KEY, installDate);
  }

  const firedDays = ls.get(RETENTION_FIRED_KEY) || [];
  const daysSince = getDaysSinceInstall(installDate);
  const toFire = RETENTION_DAYS.filter(d => d <= daysSince && !firedDays.includes(d));

  if (!toFire.length) return;

  toFire.forEach(mark => pushRetention(mark, daysSince));
  ls.set(RETENTION_FIRED_KEY, [...firedDays, ...toFire]);
};



// WEBPACK FOOTER //
// ./src/helpers/dataLayer.js